// extracted by mini-css-extract-plugin
export default {"Global":"App_Global__GW8T8"};